export const entdCarouselContainerTagName: "entd-carousel-container" =
  "entd-carousel-container" as const;
